import {Injectable} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subscription} from 'rxjs';
import {ModalAlertComponent} from '../../shared/modals/modal-alert/modal-alert.component';
import {ModalServiceErrorComponent} from '../../shared/modals/modal-service-error/modal-service-error.component';
import {ModalConfirmComponent} from '../../shared/modals/modal-confirm/modal-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private subscriptions: Subscription[] = [];
  private modalRef: BsModalRef;

  constructor(
    private readonly bsModalService: BsModalService,
  ) {
  }

  openServiceError(callback: any) {
    this.openModal('Information', [], 'service-error-modal', ModalServiceErrorComponent, callback);
  }

  openNewCalculation(callback: any): void {
    const texts = [
      'Är du säker på att du vill göra en ny beräkning?',
      'Inga uppgifter du har fyllt i kommer att sparas.'
    ];

    this.openModal('Information', texts, 'new-calculation-modal', ModalAlertComponent, callback);
  }

  openClearForm(callback: any): void {
    const texts = [
      'Är du säker på att du vill avbryta och rensa formuläret?'
    ];
    this.openModal('Information', texts, 'form-modal', ModalAlertComponent, callback);
  }

  openPapaendeInmatning(callback: any): void {
    const title = 'Välj Ändra för att uppdatera sammanställningen';

    const texts = [
      'Du håller på att ändra en uppgift. För att få rätt resultat när du beräknar beloppen måste du först klicka på "Ändra"'
    ];

    this.openModal(title, texts, 'warning-pagaende-inmatning', ModalConfirmComponent, callback);
  }

  openClearAll(callback: any): void {
    const texts = [
      'Är du säker på att du vill avbryta utan att beräkna ditt resultat?',
      'Alla uppgifter du fyllt i kommer att tas bort.'
    ];

    this.openModal('Information', texts, 'clear-all-modal', ModalAlertComponent, callback);
  }

  openModalTabelAlert(modalId: string, modalTexts: string[], tableItem: any, component: any, callback: any) {
    const initialState = {
      id: modalId,
      texts: modalTexts,
      beloppUtbetald: tableItem.beloppUtbetald,
      datum: tableItem.datum,
      inkomsttyp: tableItem.inkomsttyp,
      land: tableItem.land,
      skatt: tableItem.skatt,
      utlandskSkatt: tableItem.utlandskSkatt,
      valuta: tableItem.valuta,
    };
    this.modalRef = null;
    this.modalRef = this.bsModalService.show(component, {initialState, ignoreBackdropClick: true});

    this.subscriptions.push(
      this.bsModalService.onHide.subscribe((reason: string) => {
        if (reason === modalId + '-confirm') {
          callback();
          this.unsubscribeSubscriptions();
        }
      })
    );
  }

  openAlert(modalId: string, callback: any) {
    const texts = [
      'Är du säker på att du vill avbryta påpående inmatning?'
    ];
    this.openModal('Information', texts, modalId, ModalAlertComponent, callback);
  }

  openModal(modalTitle: string, modalTexts: string[], modalId: string, component: any, callback: any): void {
    const initialState = {
      id: modalId,
      texts: modalTexts,
      title: modalTitle
    };

    this.modalRef = null;
    this.modalRef = this.bsModalService.show(component, {initialState, ignoreBackdropClick: true});
    this.subscriptions.push(
      this.bsModalService.onHide.subscribe((reason: string) => {
        if (reason === modalId + '-confirm') {
          callback();
          this.unsubscribeSubscriptions();
        }
      })
    );
  }

  unsubscribeSubscriptions(): void {
    this.subscriptions.forEach((s: Subscription) => {
      s.unsubscribe();
    });
    this.subscriptions = [];
  }
}
